import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { EditPermissions } from '../../../../../../../shared/models';
import { FormControl, FormGroup } from '@angular/forms';
import { getEditTypes } from '../../../delegatorUtils';
import { required } from '../../../../../../../shared/utils';

export interface DisplayListForm {
  name: string;
  description: string;
  pattern: string;
  listNumbers: boolean;
  indexPattern: string;
  filterByKey: string;
  filterByValue: string;
  excludeKey: string;
  excludeValue: string;
  yes: string;
  no: string;
}

export const NODE_TYPE = 'displayList';

export class DisplayList {

  action: any = {};

  constructor() {
    this.action = {
      'actionType': NODE_TYPE,
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
    const { editFlows } = getEditTypes(editPermissions);
    const formData: DisplayListForm = this.getFromData(stepData);

    return this.buildForm(formData, editFlows);
  }

  private static getFromData(stepData: { [index: string]: any }): DisplayListForm {

    const action = stepData?.action ? stepData?.action : {};
    const actionParams = action?.actionParams ? action?.actionParams : {};
    const result = action?.result ? action?.result : {};

    const exclude = this.getKeyValue(actionParams?.exclude);
    const filterBy = this.getKeyValue(actionParams?.filterBy);

    return {
      name: action.name ? action.name : '',
      description: action.description ? action.description : '',
      pattern: actionParams.pattern ? actionParams.pattern : '',
      // listNumbers: actionParams.listNumbers ? actionParams.listNumbers : true,
      listNumbers: actionParams.listNumbers ?? true,
      indexPattern: actionParams.indexPattern ? actionParams.indexPattern : '#',
      excludeKey: exclude.key,
      excludeValue: exclude.value,
      filterByKey: filterBy.key,
      filterByValue: filterBy.value,
      yes: result.yes ? result.yes : newStepValue,
      no: result.no ? result.no : newStepValue,
    };
  }
  
  private static getKeyValue(object: {}): { key, value } {
    if (!object) {
      return {
        key: '',
        value: '',
      };
    }

    return {
      key: Object.keys(object)[0],
      value: Object.values(object)[0],
    };
  }

  private static buildForm(formData: DisplayListForm, editFlows: boolean): FormGroup {
    return new FormGroup({
      name: new FormControl({
        value: formData.name,
        disabled: !editFlows,
      }, required('Name')),
      description: new FormControl({
        value: formData.description,
        disabled: !editFlows,
      }, required('Description')),
      pattern: new FormControl({
        value: formData.pattern,
        disabled: !editFlows,
      }, required('Pattern')),
      listNumbers: new FormControl({
        value: formData.listNumbers,
        disabled: !editFlows,
      }),
      indexPattern: new FormControl({
        value: formData.indexPattern,
        disabled: !editFlows,
      }, required('Custom Index')),
      excludeKey: new FormControl({
        value: formData.excludeKey,
        disabled: !editFlows,
      }),
      excludeValue: new FormControl({
        value: formData.excludeValue,
        disabled: !editFlows,
      }),
      filterByKey: new FormControl({
        value: formData.filterByKey,
        disabled: !editFlows,
      }),
      filterByValue: new FormControl({
        value: formData.filterByValue,
        disabled: !editFlows,
      }),

      yes: new FormControl(formData.yes),
      no: new FormControl(formData.no),
    });
  }

  get nodeData(): {} {
    return {
      action: this.action,
      'type': 'action',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };
  }

  setNodeData(formData: DisplayListForm) {
    const {
      name,
      description,
      yes,
      no,
      excludeValue,
      excludeKey,
      filterByKey,
      filterByValue,
      listNumbers,
      pattern,
      indexPattern,
    } = formData;

    const exclude = {
      [excludeKey]: excludeValue,
    };

    const filterBy = {
      [filterByKey]: filterByValue,
    };

    const actionParams = {
      exclude,
      filterBy,
      listNumbers,
      pattern,
      indexPattern,

    };

    const result = {
      yes,
      no,
    };

    this.action = {
      ...this.action,
      name,
      description,
      actionParams,
      result,
    };

    console.log(this.action);
  }
}
